import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupMemberQuitContentProps {
  message: Msg;
}

export const MsgGroupMemberQuitContent = memo(function MsgGroupMemberQuitContent({
  message,
}: MsgGroupMemberQuitContentProps) {
  const { t } = useTranslation();
  const { user_name, user_id } = message.payload;

  return (
    <>
      <MsgUserText userName={user_name} userId={user_id} />
      <Text as="span" color="fg.muted" px="1">
        {t('chat.groupMessageMemberQuitText')}
      </Text>
    </>
  );
});
